import { put, call, all, takeLatest } from 'redux-saga/effects';
import notification from '../../services/notification';
import api from '../../services/api';
import types from '../types';
import { checkPostStatusVerifyUserKYC } from '../../services/kycApi';

export function* getUsers({ payload }) {
  try {
    const { data, status } = yield call(api.users.getUsersList, payload);
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.GET_USERS_SUCCESS, payload: data });
  } catch (e) {
    notification({ type: 'error', message: 'Error. Please try again later.' });
    yield put({ type: types.GET_USERS_FAILURE });
  }
}

export function* blockUser({ payload }) {
  try {
    const { status } = yield call(api.users.blockUser, payload);
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.BLOCK_USER_SUCCESS, payload });
  } catch (e) {
    notification({ type: 'error', message: 'Error. Please try again later.' });
    yield put({ type: types.BLOCK_USER_FAILURE });
  }
}

export function* verificationUser({ payload }) {
  try {
    const { status } = yield call(api.users.verificationUser, payload);
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.GET_USER_ACCOUNT_START, payload });
  } catch (e) {
    notification({ type: 'error', message: 'Error. Please try again later.' });
  }
}

export function* deleteUser({ payload }) {
  try {
    const { status } = yield call(api.users.deleteUser, payload);
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.DELETE_USER_SUCCESS, payload });
  } catch (e) {
    notification({ type: 'error', message: 'Error. Please try again later.' });
    yield put({ type: types.DELETE_USER_FAILURE });
  }
}

export function* checkVerifyStatusUserKYC(payload, id) {
  try {
    const { data, status } = yield call(api.auth.getKYCAuthToken);
    if (status < 200 || status >= 300) throw new Error('Something went wrong');

    if (data?.access_token && payload?.reference) {
      const ref = {
        reference: payload?.reference,
      };
      const kycResponse = yield call(
        checkPostStatusVerifyUserKYC,
        ref,
        data?.access_token,
      );

      yield put({
        type: types.GET_VERIFY_USER_KYC_STATUS_SUCCESS,
        payload: kycResponse,
      });

      const kycVerify = {
        type: payload?.type,
        reference: kycResponse.reference,
        status:
          kycResponse.event.split('.')[1] === 'accepted'
            ? 'approved'
            : kycResponse.event.split('.')[1] === 'timeout'
            ? 'cancelled'
            : kycResponse.event.split('.')[1],
      };

      yield put({
        type: types.UPDATE_USER_KYC_VERIFICATIONS_START,
        payload: {
          id,
          data: kycVerify,
        },
      });
    }
  } catch (error) {
    yield put({ type: types.GET_VERIFY_USER_KYC_STATUS_FAILURE });
    if (error?.response?.status === 401) return;
    console.dir(error);
  }
}

export function* users() {
  yield all([
    yield takeLatest(types.GET_USERS_START, getUsers),
    yield takeLatest(types.BLOCK_USER_START, blockUser),
    yield takeLatest(types.DELETE_USER_START, deleteUser),
    yield takeLatest(types.VERIFICATION_USER, verificationUser),
    yield takeLatest(
      types.GET_VERIFY_USER_KYC_STATUS_START,
      checkVerifyStatusUserKYC,
    ),
  ]);
}
